var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { SdsTabs } from './sds-tabs.lit';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-tab-title` represents the title element for each tab within the `sds-tabs` component.
 * It displays the label of a tab and allows control over its state (disabled or error).
 *
 * ### Attributes
 * - `disabled`: Sets the tab title element as disabled, preventing interaction.
 * - `error`: Indicates an error state on the tab title element.
 *
 * @tag sds-tab-title
 */
let SdsTabTitle = (() => {
    var _SdsTabTitle_disabled_accessor_storage, _SdsTabTitle_error_accessor_storage, _SdsTabTitle_menuElements_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tab-title')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _error_decorators;
    let _error_initializers = [];
    let _error_extraInitializers = [];
    let _menuElements_decorators;
    let _menuElements_initializers = [];
    let _menuElements_extraInitializers = [];
    var SdsTabTitle = _classThis = class extends _classSuper {
        /**
         * Sets the tab title element as disabled, preventing user interaction.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} disabled - True if this tab title element is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsTabTitle_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsTabTitle_disabled_accessor_storage, value, "f"); }
        /**
         * Indicates an error state on the tab title element.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} error - True if this tab title element is in an error state.
         */
        get error() { return __classPrivateFieldGet(this, _SdsTabTitle_error_accessor_storage, "f"); }
        set error(value) { __classPrivateFieldSet(this, _SdsTabTitle_error_accessor_storage, value, "f"); }
        get menuElements() { return __classPrivateFieldGet(this, _SdsTabTitle_menuElements_accessor_storage, "f"); }
        set menuElements(value) { __classPrivateFieldSet(this, _SdsTabTitle_menuElements_accessor_storage, value, "f"); }
        constructor() {
            super();
            _SdsTabTitle_disabled_accessor_storage.set(this, __runInitializers(this, _disabled_initializers, false));
            _SdsTabTitle_error_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _error_initializers, false)));
            _SdsTabTitle_menuElements_accessor_storage.set(this, (__runInitializers(this, _error_extraInitializers), __runInitializers(this, _menuElements_initializers, void 0)));
            __runInitializers(this, _menuElements_extraInitializers);
            this.disableClickWhenButtonIsDisabled();
        }
        disableClickWhenButtonIsDisabled() {
            this.addEventListener('click', event => {
                if (this.disabled) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    event.returnValue = false;
                }
            }, true);
        }
        render() {
            return html ` <slot></slot> <span part="sds-tab-title__separate"></span> `;
        }
        firstUpdated() {
            this.addOpenTabMenuEvent();
            this.addCloseTabMenuOnDocEvent();
        }
        addOpenTabMenuEvent() {
            var _a;
            (_a = this.menuElements[0]) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (event) => {
                const trigger = event.target;
                if (trigger.hasAttribute('selected')) {
                    trigger.removeAttribute('selected');
                }
                else {
                    if (this.parentElement instanceof SdsTabs) {
                        this.parentElement.closeTabsMenu();
                    }
                    trigger.setAttribute('selected', '');
                    event.stopPropagation();
                }
            });
        }
        addCloseTabMenuOnDocEvent() {
            document.body.addEventListener('click', () => {
                this.removeTriggerSelected();
            });
        }
        removeTriggerSelected() {
            if (this.menuElements[0]) {
                for (const child of this.menuElements[0].children) {
                    if (child.getAttribute('slot') === 'trigger' && child.hasAttribute('selected')) {
                        child.removeAttribute('selected');
                        break;
                    }
                }
            }
        }
    };
    _SdsTabTitle_disabled_accessor_storage = new WeakMap();
    _SdsTabTitle_error_accessor_storage = new WeakMap();
    _SdsTabTitle_menuElements_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTabTitle");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _disabled_decorators = [property({ type: Boolean })];
        _error_decorators = [property({ type: Boolean })];
        _menuElements_decorators = [queryAssignedElements({ selector: 'sds-menu' })];
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _error_decorators, { kind: "accessor", name: "error", static: false, private: false, access: { has: obj => "error" in obj, get: obj => obj.error, set: (obj, value) => { obj.error = value; } }, metadata: _metadata }, _error_initializers, _error_extraInitializers);
        __esDecorate(_classThis, null, _menuElements_decorators, { kind: "accessor", name: "menuElements", static: false, private: false, access: { has: obj => "menuElements" in obj, get: obj => obj.menuElements, set: (obj, value) => { obj.menuElements = value; } }, metadata: _metadata }, _menuElements_initializers, _menuElements_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTabTitle = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTabTitle = _classThis;
})();
export { SdsTabTitle };
